// extracted by css-extract-rspack-plugin
export default {"layout":"oisxeY5l","clickable":"EfQG6dth","disabled":"x3RiaNba","layoutBox":"T639rjF_","layoutBoxInner":"Gl695pus"};